export class Creator {
    public email: string;
    public name: string;
    public domain?: string;
    public integration: string;

    public constructor(data: Creator) {
        this.email = data.email;
        this.name = data.name;
        this.domain = data.domain;
        this.integration = data.integration;
    }
}
